import React, { useState, useEffect } from 'react';

const TOTAL_QUESTIONS = 50;

const SubtractFrom10000Game = () => {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState({ 1: 0, 2: 0 });
  const [level, setLevel] = useState(1);
  const [result, setResult] = useState({ 1: '', 2: '' });
  const [slots, setSlots] = useState({ 1: [], 2: [] });

  useEffect(() => {
    const generated = [];
    for (let i = 0; i < TOTAL_QUESTIONS; i++) {
      let sub = Math.floor(Math.random() * 9000) + 1000;
      let answer = (10000 - sub).toString().padStart(4, '0').split('');
      let layout = [
        '1', '0', '0', '0', '0', '-', ...sub.toString().padStart(4, '0').split(''),
        '=', 'drop', 'drop', 'drop', 'drop'
      ];
      let options = [...answer];
      while (options.length < 6) {
        let rand = Math.floor(Math.random() * 10).toString();
        if (!options.includes(rand)) options.push(rand);
      }
      generated.push({
        title: `10,000 - ${sub} = ?`,
        drops: answer,
        layout: layout,
        options: options.sort(() => Math.random() - 0.5)
      });
    }
    setQuestions(generated);
  }, []);

  useEffect(() => {
    if (questions.length > 0) {
      const q = questions[current[level]];
      setSlots((prev) => ({
        ...prev,
        [level]: q.drops.map(() => '')
      }));
      setResult((prev) => ({ ...prev, [level]: '' }));
    }
  }, [current, level, questions]);

  const handleDrop = (index, value, lvl) => {
    const newSlots = [...slots[lvl]];
    newSlots[index] = value;
    setSlots((prev) => ({ ...prev, [lvl]: newSlots }));

    const q = questions[current[lvl]];
    const correct = q.drops.every((digit, idx) => newSlots[idx] === digit);
    setResult((prev) => ({
      ...prev,
      [lvl]: correct ? '🎉 Correct!' : '❌ Try again!'
    }));
  };

  const handleNext = (lvl) => {
    setCurrent((prev) => ({
      ...prev,
      [lvl]: (prev[lvl] + 1) % questions.length
    }));
  };

  const handleLevelChange = (lvl) => {
    setLevel(lvl);
  };

  const enableDrag = (e, value) => {
    e.dataTransfer.setData('text/plain', value);
  };

  const handleSlotDrop = (e, index, lvl) => {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/plain');
    handleDrop(index, data, lvl);
  };

  const gameStyles = {
  
    body: {
      fontFamily: "'Arial Rounded MT Bold', sans-serif",
      background: 'linear-gradient(to bottom, #bbdefb, #90caf9)',
      margin: 0,
      padding: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column',
    },
    container: {
      background: '#ffffff',
      borderRadius: 20,
      padding: '2rem',
      width: '95%',
      maxWidth: '600px',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
      textAlign: 'center',
    },
    h1: {
      fontSize: '1.5rem',
      color: '#1565c0',
      wordWrap: 'break-word',
    },
    zone: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem',
      marginTop: '1.2rem',
    },
    dropSlot: (filled, correct) => ({
      fontSize: '1.2rem',
      padding: '1rem',
      minWidth: '50px',
      minHeight: '50px',
      borderRadius: '10px',
      textAlign: 'center',
      cursor: 'pointer',
      backgroundColor: correct ? '#c8e6c9' : '#e3f2fd',
      border: correct ? '2px solid green' : '2px dashed #42a5f5',
      flex: '0 0 auto',
    }),
    dragItem: {
      fontSize: '1.2rem',
      padding: '0.8rem 1.2rem',
      borderRadius: '10px',
      textAlign: 'center',
      backgroundColor: '#2196f3',
      color: 'white',
      userSelect: 'none',
      cursor: 'grab',
      flex: '0 0 auto',
    },
    staticChar: {
      fontSize: '1.2rem',
      margin: '0 4px',
    },
    result: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: '#0d47a1',
    },
    button: {
      marginTop: '1.5rem',
      padding: '0.8rem 1.5rem',
      fontSize: '1rem',
      borderRadius: '8px',
      border: 'none',
      backgroundColor: '#42a5f5',
      color: 'white',
      cursor: 'pointer',
    },
  };


  if (questions.length === 0) return <div style={gameStyles.body}>Loading...</div>;

  const q = questions[current[level]];

  return (
    <div style={gameStyles.body}>
      <div style={gameStyles.container}>
        <h1 style={gameStyles.h1}>{q.title}</h1>

        <div style={gameStyles.zone}>
          {q.layout.map((item, i) => {
            if (item === 'drop') {
              return (
                <div
                  key={i}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => handleSlotDrop(e, i - q.layout.indexOf('drop'), level)}
                  style={gameStyles.dropSlot(slots[level][i] !== '', result[level] === '🎉 Correct!', q.drops[i])}
                >
                  {slots[level][i - q.layout.indexOf('drop')] || ''}
                </div>
              );
            } else {
              return (
                <span key={i} style={gameStyles.staticChar}>{item}</span>
              );
            }
          })}
        </div>

        <div style={gameStyles.zone}>
          {q.options.map((opt, idx) => (
            <div
              key={idx}
              style={gameStyles.dragItem}
              draggable
              onDragStart={(e) => enableDrag(e, opt)}
            >
              {opt}
            </div>
          ))}
        </div>

        <div style={gameStyles.result}>{result[level]}</div>

        <button style={gameStyles.button} onClick={() => handleNext(level)}>Next ➡️</button>
        
      </div>
    </div>
  );
};

export default SubtractFrom10000Game;
